<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <div v-for="(subject,index) in row.subject_list ">

                <van-divider>项目信息{{index+1}}</van-divider>

                <van-cell-group>

                    <van-cell
                            readonly
                            clickable
                            is-link
                            input-align="right"
                            title="项目"
                            value="请选择项目"
                            @click="openSubjectPicker(subjectOptionsAll,index)"
                    />
                    <div class="operate-desc-left" v-show="subject.subjectName">{{subject.subjectName}}</div>

                    <van-action-sheet v-model="showSubjectPicker"
                                      :actions="subjectOptions"
                                      @click-overlay="onSubjectClose"
                                      @select="onSubjectSelect" />
                    <van-field
                            readonly
                            clickable
                            right-icon="arrow"
                            input-align="right"
                            label="参赛运动员"
                            placeholder="请选择运动员"
                            @click="subject.showYundongyuanPicker=true;thisSubjectIndex=index"
                    />

                    <YundongyuanPicker
                            :show="subject.showYundongyuanPicker"
                            :limit="100"
                            @onChange="onYundongyuanChange"
                            @onClose="subject.showYundongyuanPicker=false"
                            :defaultValue="subject.yundongyuan"
                            @onConfirm="onYundongyuanConfirm"
                    ></YundongyuanPicker>

                    <div class="memberResultWrap" v-show="subject.yundongyuan.length>0">
                        <div class="memberLi" v-for="(yundongyuan ,index) in subject.yundongyuan">
                            运动员{{index+1}}
                            <van-tag

                                    :key="index"
                                    round
                                    color="#fff"
                                    text-color="#666"
                                    size="large"
                                    closeable
                                    type="primary"
                                    @close="subject.yundongyuan.splice(index,1)"
                            > {{yundongyuan.name}} {{yundongyuan.num}}
                            </van-tag>
                        </div>
                    </div>

                    <van-field
                            readonly
                            clickable
                            right-icon="arrow"
                            input-align="right"
                            label="替补运动员"
                            placeholder="请选择运动员"
                            @click="subject.showTbYundongyuanPicker = true;thisSubjectIndex=index"
                    />

                    <div class="memberResultWrap" v-show="subject.tbydy.length>0">
                        <div class="memberLi" v-for="(tbydy ,index) in subject.tbydy">
                            替补运动员{{index+1}}
                            <van-tag

                                    :key="index"
                                    round
                                    color="#fff"
                                    text-color="#666"
                                    size="large"
                                    closeable
                                    type="primary"
                                    @close="subject.tbydy.splice(index,1)"
                            > {{tbydy.name}} {{tbydy.num}}
                            </van-tag>
                        </div>
                    </div>


                    <YundongyuanPicker
                            v-if="row.subject_list.length>0"
                            :show="subject.showTbYundongyuanPicker"
                            :limit="100"
                            @onChange="onTbYundongyuanChange"
                            @onClose="subject.showTbYundongyuanPicker=false"
                            :defaultValue="subject.tbydy"
                            @onConfirm="onTbYundongyuanConfirm"
                    ></YundongyuanPicker>



                    <van-cell title="自选音乐" :value="subject.music.length+'/1'">
                        <!--<template slot="icon" >-->
                        <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('zhizhaopic')"/>-->
                        <!--</template>-->
                    </van-cell>

                    <div class="row">
                        <FileUploader :fileList="subject.music" :limit="1" accept=".mp3"
                                      :name="'music'"></FileUploader>
                    </div>
                    <van-field
                            readonly
                            clickable
                            right-icon="arrow"
                            input-align="right"
                            label="教练员"
                            placeholder="请选择教练员"
                            @click="subject.showJiaolianPicker = true;thisSubjectIndex=index"
                    />

                    <JiaolianPicker
                            :show="subject.showJiaolianPicker"
                            :limit="5"
                            @onChange="onJiaolianChange"
                            @onClose="subject.showJiaolianPicker=false"
                            :defaultValue="subject.jiaolian"
                            @onConfirm="onJiaolianConfirm"
                    ></JiaolianPicker>

                    <div class="memberResultWrap" v-show="subject.jiaolian.length>0">
                        <div class="memberLi" v-for="(jiaolian ,index) in subject.jiaolian">
                            教练员{{index+1}}
                            <van-tag

                                    :key="index"
                                    round
                                    color="#fff"
                                    text-color="#666"
                                    size="large"
                                    closeable
                                    type="primary"
                                    @close="subject.jiaolian.splice(index,1)"
                            > {{jiaolian.name}} {{jiaolian.num}}
                            </van-tag>
                        </div>
                        <div style="line-height: 28px; padding-top: 10px; font-size: 14px; text-align: center ; color: #666">此处教练员顺序即为获奖证书的教练员顺序<br/>
                            <span style="color: #ff0000">请谨慎选择</span></div>
                    </div>

                </van-cell-group>

            </div>


            <div style="text-align: center">
                <van-button
                        native-type="button"
                        style="width: 3rem;"
                        size="normal" round    @click="subjectAdd">新增项目</van-button>
            </div>

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交申请</van-button>
            </div>
        </van-form>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import YundongyuanPicker from '@/components/picker/YundongyuanPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
            CaipanPicker,
            JiaolianPicker,
            YundongyuanPicker,
        },
        data: function () {
            return {
                validator,
                thisSubjectIndex:0,
                saveLoading:false,
                showSubjectPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                subjectArray:[],
                subjectOptions:[],
                subjectOptionsAll: [
                    {
                        name: '幼儿组',
                        children: [
                            {
                                name: '幼儿组',
                                children: [{ name: '舞蹈啦啦操',
                                    children:[
                                        {
                                            name: '花球规定动作',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ] }, {
                                    name: '余杭区',
                                    children:[
                                        {
                                            name: '111',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ]
                                }],
                            },
                            {
                                name: '温州',
                                children: [{ name: '鹿城区' }, { name: '瓯海区' }],
                            },
                        ],
                    },
                    {
                        name: '福建',
                        children: [
                            {
                                name: '福州',
                                children: [{ name: '鼓楼区' }, { name: '台江区' }],
                            },
                            {
                                name: '厦门',
                                children: [{ name: '思明区' }, { name: '海沧区' }],
                            },
                        ],
                    },
                ],
                row:{
                    subject_list:[],
                    subject_options:[],
                },
                formData: {
                    id: 0,
                    saiqu_name:'xxxxx',
                    danwei:'xxxxx',
                    caipan:[],
                    music:[],
                    yundongyuan:[],
                    tbydy:[],
                    jiaolian:[],
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
          document.title="赛事申请"
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            subjectAdd(){
                this.row.subject_list.push({
                    showYundongyuanPicker:false,
                    showTbYundongyuanPicker:false,
                    showJiaolianPicker:false,
                    subjectName:'',
                    subjectArray:[],
                    yundongyuan:[],
                    tbydy:[],
                    music:[],
                    jiaolian:[],
                })
            },
            openSubjectPicker(option,index){
                this.showSubjectPicker = true;
                this.thisSubjectIndex = index;
                this.subjectOptions = option;

                this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
                this.row.subject_list[this.thisSubjectIndex].subjectName = '';
            },
            onSubjectClose(){
                this.showSubjectPicker = false;
                this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
                this.row.subject_list[this.thisSubjectIndex].subjectName = '';
            },
            onSubjectSelect(item){
                console.log(item);
                this.row.subject_list[this.thisSubjectIndex].subjectArray.push(item);
                this.row.subject_list[this.thisSubjectIndex].subjectName = this.row.subject_list[this.thisSubjectIndex].subjectArray.map(item => {
                    return item.name
                }).join('-')
                if(!item.children || item.children.length==0){
                    this.showSubjectPicker = false;
                    return false;
                }
                this.subjectOptions = item.children;
            },
            onYundongyuanConfirm(values){
                console.log('onYundongyuanConfirm',values)
//                this.showYundongyuanPicker = false;
                this.row.subject_list[this.thisSubjectIndex].showYundongyuanPicker = false;
                this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
            },
            onYundongyuanChange(values){
                console.log('onYundongyaunChange',values)
                this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
            },
            onTbYundongyuanConfirm(values){
                console.log('onTbYundongyuanConfirm',values)
                this.row.subject_list[this.thisSubjectIndex].showTbYundongyuanPicker = false;
                this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
            },
            onTbYundongyuanChange(values){
                console.log('onTbYundongyuanChange',values)
                this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
            },
            onJiaolianConfirm(values){
                console.log('onJiaolianConfirm',values)
                this.row.subject_list[this.thisSubjectIndex].showJiaolianPicker = false;
                this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
            },
            onJiaolianChange(values){
                console.log('onJiaolianChange',values)
                this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
            },
            onNumTypeConfirm(value, index){
                this.row.subject_list[this.thisSubjectIndex].numTypeName = value;
                this.row.subject_list[this.thisSubjectIndex].numtype = index+1;
                this.showNumTypePicker = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

//                    if (that.formData.changdipic.length == 0) {
//                        Toast('请上传场地照片');
//                        return
//                    }
                }
                that.saveLoading = true;

                that.$api.post('/api/sai/subjectsave', {
                    'baoming_id' : that.row.id,
                    'subject_list' :JSON.stringify( that.row.subject_list.map(item =>{
                        return {
                            'subject_name' : item.subjectName,
                            'subject' : item.subjectArray[item.subjectArray.length-1].key,
                            'yundongyuan' : item.yundongyuan,
                            'jiaolian' : item.jiaolian,
                            'tbydy' : item.tbydy,
                            'music' : item.music,
                        }
                    }))
                }, (res) => {
                    that.saveLoading = false;
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/sai/step2detail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;
                    that.subjectOptionsAll = res.data.subject_options;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep2.vue?343a6a29